var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#EF7F10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7681 16.684C27.5379 15.3508 29.4631 15.3507 30.2329 16.684L42.7212 38.3159C43.4909 39.6491 42.5291 41.3156 40.9897 41.3159H16.0112C14.4717 41.3158 13.51 39.6492 14.2798 38.3159L26.7681 16.684ZM28.3999 36.1733C28.0563 36.1734 27.7679 36.2844 27.5347 36.5053C27.3013 36.7264 27.1851 37.0091 27.1851 37.353C27.1851 37.6722 27.3014 37.9488 27.5347 38.1821C27.7678 38.4152 28.0564 38.5316 28.3999 38.5317C28.7436 38.5317 29.0266 38.4152 29.2476 38.1821C29.4686 37.9488 29.5795 37.6722 29.5796 37.353C29.5796 37.0091 29.4686 36.7264 29.2476 36.5053C29.0265 36.2844 28.7437 36.1733 28.3999 36.1733ZM27.3501 25.5268L27.6821 34.3501H29.0815L29.4321 25.5268H27.3501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeAlert);
export default __webpack_public_path__ + "static/media/orange-alert.57e5c71a1d46b7a6a99dbed6d8057876.svg";
export { ForwardRef as ReactComponent };